
<iframe class="scroller" [src]="docUrl"></iframe>
